export const BUY_ORDER = "BUY_ORDER";

export function buyProcessFromOrders(price) {
  return {
    type: BUY_ORDER,
    payload: price
  };
}
